import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

const options = {
  responsive: true,
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
  },
  plugins: {
    legend: {
      display: false,
    },
  },
};

function PopulationEvolution({ data }) {
  const labels = data.map((item) => item.year.toString());
  const dataObj = data.map((item) => item.value);

  const chartData = {
    labels,
    datasets: [
      {
        fill: true,
        label: "Population",
        data: dataObj,
        backgroundColor: "rgba(244, 244, 244, 0.7)",
        borderColor: "#E88B00",
        pointBorderColor: "#E88B00",
        pointBackgroundColor: "#E88B00",
        pointHoverBackgroundColor: "#80b6f4",
        pointHoverBorderColor: "#80b6f4",
        // pointBorderWidth: 10,E88B00
        // pointHoverRadius: 10,80b6f4
        // pointHoverBorderWidth: 1,
        // pointRadius: 3,
      },
    ],
  };
  return <Line options={options} data={chartData} />;
}

export default PopulationEvolution;
